const NewEmailCampaignsMain = () => import(/* webpackChunkName: "new-email" */ '@/pages/newEmailCampaigns/main');
const NewEmailCampaignsCreate = () => import(/* webpackChunkName: "new-email-create" */ '@/pages/newEmailCampaigns/createCampaign');
const NewEmailCampaignsAnalytics = () => import(/* webpackChunkName: "new-email-analytics" */ '@/pages/newEmailCampaigns/campaignAnalytics');

export default [
  {
    path: 'email-campaigns',
    name: 'Email Campaigns',
    component: NewEmailCampaignsMain,
  },
  {
    path: 'email-campaigns/analytics/:campaign_id?',
    name: 'Email Campaigns / Analytics',
    component: NewEmailCampaignsAnalytics,
  },
  {
    path: 'email-campaigns/create/:campaign_id?',
    name: 'Email Campaigns / Create',
    component: NewEmailCampaignsCreate,
  },
  {
    path: 'email-campaigns/edit/:campaign_id?',
    name: 'Email Campaigns / Edit',
    component: NewEmailCampaignsCreate,
  },
  {
    path: 'email-campaigns/forward/:campaign_id?',
    name: 'Email Campaigns / Forward',
    component: NewEmailCampaignsCreate,
  },
];
